import { MouseEvent } from "react";

import Button from "components/common/Button";

import "./AddPaymentMethod.scss";

interface OnboardingBottomBarProps {
  isStepSkippable?: boolean;
  onSkip?: () => void;
  primaryLabel?: string;
  // eslint-disable-next-line no-unused-vars
  onPrimary?: (event?: MouseEvent<HTMLButtonElement>) => void;
  isPrimaryDisabled?: boolean;
  isLoading?: boolean;
}

function OnboardingBottomBar({
  isStepSkippable = false,
  onSkip = () => {},
  primaryLabel = "",
  onPrimary = () => {},
  isPrimaryDisabled = false,
  isLoading = false,
}: OnboardingBottomBarProps) {
  const showPrimary = Boolean(primaryLabel);
  const showSkip = isStepSkippable;

  if (!showPrimary && !showSkip) {
    return null;
  }

  const hasBothActions = showPrimary && showSkip;
  const bottomButtonClassName = `onboarding-bottom-button${hasBothActions ? " onboarding-bottom-button--with-skip" : ""}`;

  return (
    <div className={bottomButtonClassName}>
      <div className="onboarding-bottom-button-container">
        {showSkip && (
          <Button
            onClick={onSkip}
            name="Skip for now"
            size="large"
            label="Skip for now"
            isFullWidth={false}
          />
        )}
        {showPrimary && (
          <Button
            onClick={onPrimary}
            name={primaryLabel}
            size="large"
            label={primaryLabel}
            isFullWidth={false}
            isDisabled={isPrimaryDisabled}
            isLoading={isLoading}
          />
        )}
      </div>
    </div>
  );
}

export default OnboardingBottomBar;
